'use strict';

(function (Drupal, drupalSettings, once) {
  Drupal.behaviors.facet_analytics = {
    attach: function (context) {

      // Use Drupal once() to avoid double-binding events.
      const elements = once('facet-analytic', '.facet-item', context);

      elements.forEach(function (el) {
        el.addEventListener('click', function () {

          // Extract facet value
          const valueEl = el.querySelector('.facet-item__value');
          if (!valueEl) return;

          const value = valueEl.textContent.trim();
          const facetAction = 'clicked_facet';

          // Find facet category label
          const block = el.closest('.block-facets');
          if (!block) return;

          const heading = block.querySelector('h2');
          if (!heading) return;

          const category = heading.textContent.trim();

          // Send event to Google Analytics (gtag)
          if (typeof gtag === 'function') {
            gtag('event', facetAction, {
              category: category,
              value: value,
              page: drupalSettings.knmt_misc?.facet || ''
            });
          }
        });
      });
    }
  };
})(Drupal, drupalSettings, once);
